import { createMarker } from "./createMarker";

export function createMarkers(
    map: google.maps.Map,
    markers: google.maps.Marker[],
    bounds: google.maps.LatLngBounds,
    stores: any[]
) {
    if (!stores || stores.length === 0) return;

    stores.forEach((store) => createMarker(store, map, markers, bounds));
}
